module.exports = __webpack_public_path__ + "img/newLogo.39d4903f.svg";